module.exports = __webpack_public_path__ + "1d78ca9885db75affe2ee7abb56c5f60.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/4.jpg
 ** module id = 214
 ** module chunks = 0
 **/